import { gql } from '@apollo/client';

export const CREATE_OR_UPDATE_FAVORITE_LINKS = gql`
    mutation CreateOrUpdateFavoriteLinks($data: FavoriteLinksInput!) {
        createOrUpdateFavoriteLinks(data: $data) {
            id
        }
    }
`;
